/**
 * @fileoverview Redux hooks with TypeScript support.
 * @summary Typed hooks for Redux store access.
 *
 * @package KaraoNow
 * @module apps/front/src/hooks/redux
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from '../store/index.js'

/**
 * @summary Typed useDispatch hook.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export const useAppDispatch = () => useDispatch<AppDispatch>()

/**
 * @summary Typed useSelector hook.
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
